export default __webpack_public_path__ + "static/media/image2.ef1bdb1f.png";